module.exports = __webpack_public_path__ + "media/images/welcome/feature1-3-b7b7225ab4207ec28ec076fc8b1feb5c.png";